<ngx-loading-bar [color]="'#5047FF'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar>
<app-loader></app-loader>
<app-tap-to-top></app-tap-to-top>
<router-outlet></router-outlet>